import { useMemo, useRef } from 'react';
import { useAppSelector } from 'store/hooks';
import { makeSelectDuplicateGroupBySubscriptionId } from '../selectors';
/**
 * The duplicate group `anchorId` belongs to, as it was when the screen first
 * had it. Resolving the group changes the store while the screen is still
 * showing: each member's response lands on its own, so a group of three can
 * shrink to two before it disappears. A path screen only ever resolves the
 * group itself, so it keeps showing the group it opened with until it navigates
 * away or a success screen covers it.
 */
const useDuplicateGroup = (anchorId) => {
    const selectGroup = useMemo(makeSelectDuplicateGroupBySubscriptionId, []);
    const storeGroup = useAppSelector((store) => selectGroup(store, anchorId));
    const firstGroup = useRef(storeGroup);
    if (!firstGroup.current)
        firstGroup.current = storeGroup;
    return firstGroup.current;
};
export default useDuplicateGroup;
